import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$enableDineInNameMode',
  initialState,
  reducers: {
    setEnableDineInNameMode(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setEnableDineInNameMode } = slice.actions;
export default slice.reducer;
